import type { SessionItemsNavFilterValue } from "./types";

export const SESSION_ITEMS_NAV_FILTER_ORDER: SessionItemsNavFilterValue[] = [
	"correct",
	"incorrect",
	"skipped",
	"marked",
];

export const SESSION_ITEMS_NAV_FILTER_LABELS: Record<
	SessionItemsNavFilterValue,
	string
> = {
	correct: "Correct",
	incorrect: "Incorrect",
	skipped: "Skipped",
	marked: "Marked for review",
	answered: "Answered",
	unanswered: "Unanswered",
};

export const SESSION_ITEMS_NAV_EMPTY_FILTERED_TITLE = "No matching questions";
export const SESSION_ITEMS_NAV_EMPTY_FILTERED_SUBTITLE =
	"Clear filters to see all questions in this session.";
export const SESSION_ITEMS_NAV_EMPTY_CTA = "Clear filters";

export const SESSION_ITEMS_NAV_EMPTY_NO_ITEMS_TITLE = "No questions";
export const SESSION_ITEMS_NAV_EMPTY_NO_ITEMS_SUBTITLE =
	"Questions in this session will appear here.";
